<template>
    <section class="inner_banner">
        <div class="container">
            <h2 class="title">Media</h2>
            <div class="media">
                <div class="video">
                    <div class="video_inner">
                        <video width="100%" id="myVideo" controls="controls">
                            <source src="../assets/images/1.mp4" type="video/mp4">
                            <source src="../assets/images/1.mp4" type="video/ogg">
                            Your browser does not support HTML5 video.
                        </video>
                    </div>
                    <div class="video_inner">
                        <video width="100%" id="myVideo" controls="controls">
                            <source src="../assets/images/11.mp4" type="video/mp4">
                            <source src="../assets/images/11.mp4" type="video/ogg">
                            Your browser does not support HTML5 video.
                        </video>
                    </div>
                    <div class="video_inner">
                        <video width="100%" id="myVideo" controls="controls">
                            <source src="../assets/images/2.mp4" type="video/mp4">
                            <source src="../assets/images/2.mp4" type="video/ogg">
                            Your browser does not support HTML5 video.
                        </video>
                    </div>
                    <div class="video_inner">
                        <video width="100%" id="myVideo" controls="controls">
                            <source src="../assets/images/22.mp4" type="video/mp4">
                            <source src="../assets/images/22.mp4" type="video/ogg">
                            Your browser does not support HTML5 video.
                        </video>
                    </div>
                    <div class="video_inner">
                        <video width="100%" id="myVideo" controls="controls">
                            <source src="../assets/images/3.mp4" type="video/mp4">
                            <source src="../assets/images/3.mp4" type="video/ogg">
                            Your browser does not support HTML5 video.
                        </video>
                    </div>
                    <div class="video_inner">
                        <video width="100%" id="myVideo" controls="controls">
                            <source src="../assets/images/33.mp4" type="video/mp4">
                            <source src="../assets/images/33.mp4" type="video/ogg">
                            Your browser does not support HTML5 video.
                        </video>
                    </div>
                </div>
            </div>
            <div class="screenshot">
                <h2 class="title">Screenshots</h2>
                <article class="row">
                    <aside class="col-md-6">
                        <div class="screenshot_inner">
                            <div class="-fx-gal-item">
                                <div class="-fx-gal-image-thumb" tabindex="1">
                                    <img src="../assets/images/screenshot1.jpg" />
                                </div>
                                <div class="-fx-gal-image-big">
                                    <img src="../assets/images/screenshot1-b.jpg" />
                                </div>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-md-6">
                        <div class="screenshot_inner">
                            <div class="-fx-gal-item">
                                <div class="-fx-gal-image-thumb" tabindex="1">
                                    <img src="../assets/images/screenshot2.jpg" />
                                </div>
                                <div class="-fx-gal-image-big">
                                    <img src="../assets/images/screenshot2-b.jpg" />
                                </div>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-md-6">
                        <div class="screenshot_inner">
                            <div class="-fx-gal-item">
                                <div class="-fx-gal-image-thumb" tabindex="1">
                                    <img src="../assets/images/screenshot3.jpg" />
                                </div>
                                <div class="-fx-gal-image-big">
                                    <img src="../assets/images/screenshot3-b.jpg" />
                                </div>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-md-6">
                        <div class="screenshot_inner">
                            <div class="-fx-gal-item">
                                <div class="-fx-gal-image-thumb" tabindex="1">
                                    <img src="../assets/images/screenshot4.jpg" />
                                </div>
                                <div class="-fx-gal-image-big">
                                    <img src="../assets/images/screenshot4-b.jpg" />
                                </div>
                            </div>
                        </div>
                    </aside>
                </article>
            </div>
        </div>
<!--        </div>-->
    </section>
</template>

<script>
export default {
name: "Media"
}
</script>

<style scoped>

</style>
